import { render } from "./AboutUsShort.vue?vue&type=template&id=3f6984ce"
import script from "./AboutUsShort.vue?vue&type=script&lang=js"
export * from "./AboutUsShort.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__